import { render, staticRenderFns } from "./TgHomeShop.vue?vue&type=template&id=bbcf5032&"
import script from "./TgHomeShop.vue?vue&type=script&lang=js&"
export * from "./TgHomeShop.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports